import React from "react";
import ImportResidentImportExcel from "../Imports/import";
import SuccessfulImport from "../Imports/successfulImport";
import ImportTableView from "../Imports/tableView";

const ResidentImport = ({ organization }) => {
  const [csvData, setCsvData] = React.useState(null);
  const [importFinished, setImportFinished] = React.useState(false);

  return (
    <React.Fragment>
      {!importFinished && !csvData && (
        <ImportResidentImportExcel setCsvData={setCsvData} />
      )}
      {!importFinished && csvData && (
        <ImportTableView
          csvData={csvData}
          setImportFinished={setImportFinished}
        />
      )}
      {importFinished && (
        <SuccessfulImport organizationName={organization.name} />
      )}
    </React.Fragment>
  );
};

export default ResidentImport;
